import React from 'react';
import { Helmet } from "react-helmet";

const TermsAndConditions = () => {
  return (
    <>
      <Helmet>
        <title>Terms and Conditions | Elly Decor</title>
        <meta name="title" content="Terms and Conditions | Elly Decor" />
        <meta
          name="description"
          content="Read Elly Decor's Terms and Conditions to understand the rules, policies, and legal agreements governing the use of our website and services."
        />
      </Helmet>

      <div className="auto-container py-5 text-justify">
        <h2>Terms and Conditions for Elly Decor</h2>
        <p><strong>Effective Date:</strong> [Date of Policy Implementation]</p>
        <p>
          Welcome to ellydecor.in ("Site"). These Terms and Conditions ("Terms") govern your use of our Site and the services offered by Elly Decor ("we," "us," or "our"). By accessing or using our Site, you agree to be bound by these Terms. If you do not agree with any part of these Terms, you must not use our Site.
        </p>

        <h4>1. Acceptance of Terms</h4>
        <p>By accessing and using ellydecor.in, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions, including any future modifications. These Terms constitute a binding legal agreement between you and Elly Decor.</p>

        <h4>2. Use of the Site</h4>
        <ul>
          <li><strong>Eligibility:</strong> You must be at least 18 years of age to use our Site and services. By using our Site, you represent and warrant that you meet this requirement.</li>
          <li><strong>Account Creation:</strong> You may be required to create an account to access certain features of the Site. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.</li>
          <li><strong>Site Content:</strong> All content is the property of Elly Decor or its licensors and is protected by intellectual property laws. You may not use it without prior written consent.</li>
          <li><strong>Prohibited Conduct:</strong> You agree not to:
            <ul>
              <li>Post or transmit unauthorized material</li>
              <li>Engage in fraudulent activity</li>
              <li>Interfere with site operations</li>
              <li>Attempt unauthorized access</li>
              <li>Use automated systems to access the Site</li>
            </ul>
          </li>
          <li><strong>Site Modifications:</strong> We may modify, suspend, or discontinue the Site at any time without notice.</li>
        </ul>

        <h4>3. Product Information and Orders</h4>
        <ul>
          <li><strong>Product Descriptions:</strong> We strive for accuracy but do not guarantee it. Colors and textures may vary.</li>
          <li><strong>Pricing:</strong> Prices may change without notice; we are not responsible for typographical errors.</li>
          <li><strong>Orders:</strong> All orders are subject to acceptance. We may refuse or cancel for reasons like unavailability, errors, or suspected fraud.</li>
          <li><strong>Payment:</strong> Full payment is required. We use third-party payment processors.</li>
          <li><strong>Shipping and Delivery:</strong> Times are estimates only; delays may occur. Costs and options are shown at checkout.</li>
          <li><strong>Returns and Exchanges:</strong> See our Returns and Exchanges Policy.</li>
        </ul>

        <h4>4. Intellectual Property</h4>
        <p>The Site and its content are owned by Elly Decor and protected by applicable laws. You may not use our trademarks or content without permission.</p>

        <h4>5. User-Generated Content</h4>
        <p>By submitting content, you grant us a worldwide, royalty-free, perpetual license to use it. You must have rights to your content and ensure it does not violate laws or rights of others.</p>

        <h4>6. Third-Party Links</h4>
        <p>We are not responsible for third-party websites linked from our Site. Use them at your own risk.</p>

        <h4>7. Disclaimer of Warranties</h4>
        <p>We disclaim all warranties to the fullest extent permitted by law. Use the Site at your own risk.</p>

        <h4>8. Limitation of Liability</h4>
        <p>We are not liable for indirect, incidental, or consequential damages arising from your use of the Site.</p>

        <h4>9. Indemnification</h4>
        <p>You agree to indemnify and hold us harmless from claims arising from your use of the Site or violation of these Terms.</p>

        <h4>10. Governing Law</h4>
        <p>These Terms are governed by the laws of India.</p>

        <h4>11. Dispute Resolution</h4>
        <p>Disputes shall be resolved by binding arbitration in Delhi, India, in English, under the Arbitration and Conciliation Act, 1996.</p>

        <h4>12. Termination</h4>
        <p>We may suspend or terminate your access at any time for any reason.</p>

        <h4>13. Severability</h4>
        <p>If any provision is invalid, the remainder will remain in effect.</p>

        <h4>14. Waiver</h4>
        <p>No waiver of any term is a continuing waiver or a waiver of any other term.</p>

        <h4>15. Changes to These Terms</h4>
        <p>We may update these Terms and post the revised version on our Site. Continued use means you accept the changes.</p>

        <h4>16. Contact Us</h4>
        <p>
          Elly Decor<br />
          [Your Full Business Address]<br />
          Email: [Your Email Address]<br />
          Phone: [Your Phone Number]
        </p>
      </div>
    </>
  );
};

export default TermsAndConditions;
